// Generated by Melange


function allows(role, action) {
  switch (role) {
    case /* Owner */ 0 :
      return true;
    case /* Admin */ 1 :
      switch (action) {
        case /* Read */ 0 :
        case /* Edit_environment */ 1 :
          break;
        case /* Manage_billing */ 5 :
        case /* Delete_workspace */ 6 :
          return false;
        default:
          return true;
      }
      break;
    case /* Member */ 2 :
      switch (action) {
        case /* Read */ 0 :
        case /* Edit_environment */ 1 :
          break;
        case /* Execute */ 2 :
          return true;
        default:
          return false;
      }
      break;
    case /* Viewer */ 3 :
      break;
  }
  switch (action) {
    case /* Read */ 0 :
    case /* Edit_environment */ 1 :
      return true;
    default:
      return false;
  }
}

export {
  allows,
}
/* No side effect */
